export enum DeliveryStatusEnum {
    CREATED = 'created',
    HANDED_OVER = 'handed_over',
    CANCELLED = 'cancelled',
    IN_TRANSIT = 'in_transit',
    ARRIVED_AT_BRANCH = 'arrived_at_branch',
    DELIVERY_FAILED = 'delivery_failed',
    DELIVERED = 'delivered',
    RETURNING = 'returning',
    RETURNED = 'returned',
    DISPOSED = 'disposed',
}